import BaseHandler from "../BaseHandler";
import { PushTwoStepVerificationResponse } from "../../proto/PushTwoStepVerification_pb";
import { memoryHistory } from "../../index";
import { ROUTE_LOGIN_PASSWORD } from "../../constants/routes";
import { setStorage } from "../../libs/storage";
import { STORAGE_AUTHOR_HASH, STORAGE_USER_ID } from "../../constants/localstorage";

export default class HandlePushTwoStepVerificationResponse extends BaseHandler<PushTwoStepVerificationResponse> {
  handle() {
    const pushTwoStepVerificationResponse = this.response.toObject();
    setStorage(STORAGE_USER_ID, pushTwoStepVerificationResponse.userId);
    setStorage(STORAGE_AUTHOR_HASH, pushTwoStepVerificationResponse.authorHash);
    memoryHistory.push(ROUTE_LOGIN_PASSWORD);
  }
}
